import BeritaAcaraStockOpname from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpname';

export default class BeritaAcaraStockOpnameFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockOpnamePlanId  = '';
		this.stockOpnamePlanName = '';
		this.areaId  = '';
		this.areaCode = '';
		this.vendorId  = '';
		this.vendorCode = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.isStockOpnamed = false;
		this.isNotStockOpnamed = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockOpnamePlanId : '0',
			stockOpnamePlanName : '0',
			areaId : '0',
			areaCode : '0',
			vendorId : '0',
			vendorCode : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
			isStockOpnamed : '0',
			isNotStockOpnamed : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}